<template>
  <div>
    <CCard></CCard>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <div class="flex flex-column">
              <h1>Lokalizacja</h1>
              <div>
                <strong>(i)</strong> Kliknij etykietę, aby edytować. <strong>Naciśnij
                Zapisz, Ctrl+Enter lub Shift+Enter, aby zapisać.</strong> Użyj filtrów,
                aby wyświetlić inne języki.
              </div>
            </div>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12">
                <div md="12">
                  <input
                    class="searchinput"
                    id="searchInput"
                    v-model="searchValue"
                    @change="mthSearch()"
                    type="text"
                    placeholder="Wyszukiwarka"
                  />
                  <input type="checkbox" v-model="plvisible" />PL
                  <input type="checkbox" v-model="czvisible" />CZ
                  <input type="checkbox" v-model="skvisible" />SK
                  <input type="checkbox" v-model="huvisible" />HU
                  <input type="checkbox" v-model="rovisible" />RO
                  <input type="checkbox" v-model="envisible" />EN
                  <input type="checkbox" v-model="frvisible" />FR
                  <input type="checkbox" v-model="devisible" />DE
                  <button class="btn-only-pl" @click="mthToggleLangs">{{ onlyPlMode ? 'Wszystkie' : 'Tylko PL' }}</button>
                </div>
                <CRow>
                  <CCol sm="12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">Element</th>
                          <th v-if="plvisible" scope="col">PL</th>
                          <th v-if="czvisible" scope="col">CZ</th>
                          <th v-if="skvisible" scope="col">SK</th>
                          <th v-if="huvisible" scope="col">HU</th>
                          <th v-if="rovisible" scope="col">RO</th>
                          <th v-if="envisible" scope="col">EN</th>
                          <th v-if="frvisible" scope="col">FR</th>
                          <th v-if="devisible" scope="col">DE</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in datamain"
                          v-bind:key="`${item.id}-${index}`"
                        >
                          <td :title="item.id">{{ item.item }}</td>
                          <td v-if="plvisible">
                            <localisation-editor-helper
                              :key="refresher"
                              :lang_id="item.lang_id"
                              :textinl="item.pl"
                              :idpk="item.plidpk"
                              v-on:emitedChanged="
                                mthEmitedChanged($event, index, 'pl')
                              "
                            />
                          </td>
                          <td v-if="czvisible">
                            <localisation-editor-helper
                              :key="refresher"
                              :lang_id="item.lang_id"
                              :textinl="item.cz"
                              :idpk="item.czidpk"
                              v-on:emitedChanged="
                                mthEmitedChanged($event, index, 'cz')
                              "
                            />
                          </td>
                          <td v-if="skvisible">
                            <localisation-editor-helper
                              :key="refresher"
                              :lang_id="item.lang_id"
                              :textinl="item.sk"
                              :idpk="item.skidpk"
                              v-on:emitedChanged="
                                mthEmitedChanged($event, index, 'sk')
                              "
                            />
                          </td>
                          <td v-if="huvisible">
                            <localisation-editor-helper
                              :key="refresher"
                              :lang_id="item.lang_id"
                              :textinl="item.hu"
                              :idpk="item.huidpk"
                              v-on:emitedChanged="
                                mthEmitedChanged($event, index, 'hu')
                              "
                            />
                          </td>
                          <td v-if="rovisible">
                            <localisation-editor-helper
                              :key="refresher"
                              :lang_id="item.lang_id"
                              :textinl="item.ro"
                              :idpk="item.roidpk"
                              v-on:emitedChanged="
                                mthEmitedChanged($event, index, 'ro')
                              "
                            />
                          </td>
                          <td v-if="envisible">
                            <localisation-editor-helper
                              :key="refresher"
                              :lang_id="item.lang_id"
                              :textinl="item.en"
                              :idpk="item.enidpk"
                              v-on:emitedChanged="
                                mthEmitedChanged($event, index, 'en')
                              "
                            />
                          </td>
                          <td v-if="frvisible">
                            <localisation-editor-helper
                              :key="refresher"
                              :lang_id="item.lang_id"
                              :textinl="item.fr"
                              :idpk="item.fridpk"
                              v-on:emitedChanged="
                                mthEmitedChanged($event, index, 'fr')
                              "
                            />
                          </td>
                          <td v-if="devisible">
                            <localisation-editor-helper
                              :key="refresher"
                              :lang_id="item.lang_id"
                              :textinl="item.de"
                              :idpk="item.deidpk"
                              v-on:emitedChanged="
                                mthEmitedChanged($event, index, 'de')
                              "
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import LocalisationEditorHelper from "./b2bisz/LocalisationEditorHelper.vue";

export default {
  name: "b2bsalesrepresentatives",
  components: {
    LocalisationEditorHelper,
  },
  created() {
    this.mthFillData();
  },
  directives: {
    focus: {
      // directive definition
      inserted: function (el) {
        el.focus();
      },
    },
  },
  data() {
    return {
      refresher: 0,
      searchValue: "",
      editindex: -1,
      newfirstname: "",
      datamain: [],
      plvisible: true,
      czvisible: true,
      skvisible: true,
      huvisible: true,
      rovisible: true,
      envisible: true,
      frvisible: true,
      devisible: true,
      brakujace: false,
      onlyPlMode: false,
    };
  },
  methods: {
    mthPlaceholderForEmptyValue(value) {
      //if value is empty, there is no place to click for edit...
      if (value == "") return "(pole jest puste, kliknij aby edytować(2))";
      console.log('value: ', value);
      return "";
    },
    mthEmitedChanged(event, index, lang) {
      //event: native from textarea or {text: 'bla'} from vue2-editor
      let newvalue = ``;
      if (Object.prototype.hasOwnProperty.call(event, "text"))
        newvalue = event.text;
      else newvalue = event.target.value;

      switch (lang) {
        case "pl":
          this.datamain[index].pl = newvalue;
          break;
        case "cz":
          this.datamain[index].cz = newvalue;
          break;
        case "sk":
          this.datamain[index].sk = newvalue;
          break;
        case "hu":
          this.datamain[index].hu = newvalue;
          break;
        case "ro":
          this.datamain[index].ro = newvalue;
          break;
        case "en":
          this.datamain[index].en = newvalue;
          break;
        case "fr":
          this.datamain[index].fr = newvalue;
          break;
        case "de":
          this.datamain[index].de = newvalue;
          break;
      }
      console.log(lang);
      //console.log(this.datamain[index][lang]);
    },
    mthToggleLangs() {
      if (this.onlyPlMode) {
        // Switch to all languages
        this.plvisible = true;
        this.czvisible = true;
        this.skvisible = true;
        this.huvisible = true;
        this.rovisible = true;
        this.envisible = true;
        this.frvisible = true;
        this.devisible = true;
      } else {
        // Switch to only PL
        this.plvisible = true;
        this.czvisible = false;
        this.skvisible = false;
        this.huvisible = false;
        this.rovisible = false;
        this.envisible = false;
        this.frvisible = false;
        this.devisible = false;
      }
      this.onlyPlMode = !this.onlyPlMode;
    },
    mthSearch() {
      this.mthFillData(this.searchValue);
    },
    mthGoToEdit(id) {
      this.$router.replace("/b2buserDetails/" + id);
    },
    mthSanitizeHTML(t) {
      let doc = new DOMParser().parseFromString(t, "text/html");
      return doc.body.textContent || "";
    },
    mthFillData() {
      var apiurl =
        process.env.VUE_APP_API_URL +
        "/b2blocalisation?s=" +
        encodeURIComponent(this.searchValue);

      var that = this;

      this.$axios({
        method: "get",
        url: apiurl,
      })
        .then(function (response) {
          //console.log("api response:");
          console.log(response.data);
          that.datamain = response.data;
        })
        .catch(function (error) {
          console.log(error);
          that.loginsuccess = false;
          that.loginresultmsg = "Brak połączenia z API (" + error + ").";
        });
    },
  },
};
</script>

<style scoped>
input {
  margin-bottom: 3px;
}
.flex {
  display: flex;
  justify-content: space-between;
}
input[type="checkbox"] {
  margin-left: 4px;
  margin-right: 2px;
}
.searchinput {
  margin-right: 8px;
}
.btn-only-pl {
  margin-left: 8px;
  padding: 2px 8px;
  font-size: 0.85em;
  cursor: pointer;
}
.table {
  width: 100%;
  font-size: 0.85em;
}
.table td:first-child,
.table th:first-child {
  width: 10%;
  max-width: 150px;
}
</style>